import { render, staticRenderFns } from "./FoodSelector.vue?vue&type=template&id=53a800d8&scoped=true"
import script from "./FoodSelector.vue?vue&type=script&lang=js"
export * from "./FoodSelector.vue?vue&type=script&lang=js"
import style0 from "./FoodSelector.vue?vue&type=style&index=0&id=53a800d8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a800d8",
  null
  
)

export default component.exports